/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Role_Admin_DInputs */

const en_mk_sec_pg_role_admin_d = /** @type {(inputs: Mk_Sec_Pg_Role_Admin_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invites and removes members, creates divisions and agents, decides approvals, reads the audit trail.`)
};

const id_mk_sec_pg_role_admin_d = /** @type {(inputs: Mk_Sec_Pg_Role_Admin_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengundang dan mengeluarkan anggota, membuat divisi dan agen, memutuskan approval, membaca catatan audit.`)
};

/**
* | output |
* | --- |
* | "Invites and removes members, creates divisions and agents, decides approvals, reads the audit trail." |
*
* @param {Mk_Sec_Pg_Role_Admin_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_role_admin_d = /** @type {((inputs?: Mk_Sec_Pg_Role_Admin_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Role_Admin_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_role_admin_d(inputs)
	return en_mk_sec_pg_role_admin_d(inputs)
});